export default "__VITE_ASSET__6QCVZS9W__"